<!-- src/components/Home.vue -->

<template>
  <div>
    <header-component />
    <bookingDetail-component />
    <footer-component />
  </div>
</template>
<script>
import headerComponent from '../header/headerComponent.vue';
import bookingDetailComponent from '../booking/bookingDetailComponent.vue';
import footerComponent from '../footer/footerComponent.vue';

export default {
  name: 'bookingComponent',
  components: {
    headerComponent,
    bookingDetailComponent,
    footerComponent,
  },
  mounted() {
  // Create a script tag
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.text = `
    function gtag_report_conversion(url) {
      var callback = function () {
        if (typeof(url) != 'undefined') {
          window.location = url;
        }
      };
      gtag('event', 'conversion', {
          'send_to': 'AW-11360225674/mK1ICJLlsfEaEIqT_agq',
          'event_callback': callback
      });
      return false;
    }
  `;
  document.head.appendChild(script);
}
  
};
</script>
